export enum OrderTypesActions {
    SET_SELECTED_ORDER_TYPES = "setSelectedOrderTypes",
    SET_ORDER_TYPE = "setOrderType",
    SET_EDITING= 'setEditingOrderTypes',
    CLEAR_ORDER_TYPES_DATA = "clearOrderTypesData",
    SET_ACTIVE_ORDERTYPE_ITEM = "setActiveOrderTypeItem",
    RELOAD = "reloadOrderTypes",
    ADD = "addOrderType",
    SET_ORDER_TYPES="setOrderTypes"
  }